
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class LayoutCol1 extends Vue {
  private name = 'LayoutCol1';
  @Prop()
  private classWrap!: string[];
}
